export default {
  fontsColor: {
    placeHolder: {
      core: "#808080",
    },
    textColor: {
      core: "#333333",
      tint30Percent: "#808080",
      dark: "#333333",
      light: "#808080",
    },
    detailTextColor: {
      core: "#808080",
    },
    white: {
      core: "#FFFFFF",
    },
  },
  coreColors: {
    jllRed: {
      core: "#E30613",
      accent: "#FF444F",
      primary: "#cc5248",
    },
    white: {
      core: "#FFFFFF",
    },
    black: {
      core: "#000000",
      tint75Percent: "#404040",
      tint50Percent: "#808080",
      tint30Percent: "#B2B2B2",
      tint25Percent: "#BFBFBF",
      tint10Percent: "#E5E5E5",
    },
    steel: {
      core: "#626468",
      tint75Percent: "#898B8E",
      tint50Percent: "#B0B1B3",
      tint30Percent: "#CFD0D1",
      tint25Percent: "#D8D8D9",
      tint10Percent: "#EFEFEF",
    },
    concrete: {
      core: "#B1B2B4",
      tint75Percent: "#C5C5C7",
      tint50Percent: "#D8D8D9",
      tint30Percent: "#E7E7E8",
      tint25Percent: "#EBECEC",
      tint10Percent: "#F7F7F7",
    },
    stone: {
      core: "#D0C9B7",
      tint75Percent: "#E4E0D5",
      tint50Percent: "#EDEBE3",
      tint30Percent: "#F4F2EE",
      tint25Percent: "#F6F5F1",
      tint10Percent: "#FBFAF9",
    },
  },
  supportingColors: {
    violet: {
      core: "#7874B5",
      tint75Percent: "#9A97C7",
      tint50Percent: "#BCBADA",
      tint30Percent: "#D6D5E8",
      tint25Percent: "#DDDCED",
      tint10Percent: "#F1F1F7",
    },
    purple: {
      core: "#602376",
      tint75Percent: "#885A98",
      tint50Percent: "#AF91BA",
      tint30Percent: "#CFBDD5",
      tint25Percent: "#D7C8DD",
      tint10Percent: "#EFE9F1",
    },
    raspberry: {
      core: "#9A054A",
      tint75Percent: "#B34477",
      tint50Percent: "#CC82A4",
      tint30Percent: "#E0B4C8",
      tint25Percent: "#E6C0D2",
      tint10Percent: "#F4E6EC",
    },
    orange: {
      core: "#ED700A",
      tint75Percent: "#F19447",
      tint50Percent: "#F6B784",
      tint30Percent: "#F9D4B5",
      tint25Percent: "#F6F5F1",
      tint10Percent: "#FDF0E6",
    },
    blue: {
      core: "#2D4F5E",
      tint110Percent: "#223C47",
      tint75Percent: "#4E89A3",
      tint50Percent: "#8EB7C9",
      tint25Percent: "#D3E3EA",
    },
    turqoise: {
      core: "#003F55",
      tint75Percent: "#007DAA",
      tint50Percent: "#00BCFF",
      tint25Percent: "#AAE9FF",
    },
    green: {
      core: "#556C3A",
      tint75Percent: "#789852",
      tint50Percent: "#9AB678",
      tint25Percent: "#BBCEA4",
    },
    gold: {
      core: "#EAA509",
      tint75Percent: "#F7BA2F",
      tint50Percent: "#F9CA60",
      tint25Percent: "#FBE0A1",
    },
  },
  componentColors: {},
  supportingColorOrder: ["violet", "purple", "raspberry", "orange"],
  mapColors: {
    water: {
      core: "#D3E3EA",
    },
    land: {
      core: "#BBCEA4",
    },
  },
};

const STATUS = ["#DBD5C6", "#FFA900", "#E80000", "#666666", "#2FB200"];

const TYPE = [
  "#0d0404",
  "#280e0b",
  "#431612",
  "#5d1f1a",
  "#782921",
  "#933128",
  "#ad3a30",
  "#c84437",
  "#cf5c52",
  "#d7756c",
  "#de8f87",
  "#e5a7a2",
  "#edc0bc",
  "#f4dad7",
  "#fbf2f2",
];

export const CHART_COLORS = {
  STATUS,
  TYPE,
};
